import * as Vue from "vue";
import {Component, Inject, Watch} from "vue-property-decorator";
import "./toolbar.styl";
import {UserStatus} from "../../../models/userStatus";
import {Routes} from "../../../router";
import {eventBus, signalNames} from "../../../bus";
import {session} from "../../../stores/session";
const template = require("./toolbar.vue");

@Component({
  template: template
})
export class ToolbarComponent extends Vue {

  title = "";
  isLoggingOut = false;
  isLogged = false;
  isGlobalLoading = false;
  backAction: Function = null;
  reloadAction: Function = null;

  created() {
    this.isLogged = this.$store.state.session.status === UserStatus.LoggedIn;
    this.$store.watch(
      () => this.$store.state.session.status,
      () => this.isLoggingOut = this.$store.state.session.status === UserStatus.Logging
    );
    this.$store.watch(
      () => this.$store.state.session.globalLoader,
      () => this.isGlobalLoading = this.$store.state.session.globalLoader
    );
    eventBus.$on(signalNames.setToolbarOptions, this.setToolbarOptions);
  }

  beforeDestroy() {
    eventBus.$off(signalNames.setToolbarOptions, this.setToolbarOptions);
  }

  setToolbarOptions(options: {title: string, backAction: Function, reloadAction: Function}) {
    this.title = options.title;
    this.backAction = options.backAction ? options.backAction : null;
    this.reloadAction = options.reloadAction ? options.reloadAction : null;
  }

  logoutAction() {
    session.dispatchSignOut(this.$store)
      .then(() => this.$router.push(Routes.login));
  }

  goToRoute(url?) {
    this.$router.push(Routes.login);
  }

  toggleLeftSidebar() {
    eventBus.$emit(signalNames.changeSidebarStatus, null);
  }

  @Watch("$route")
  onRouteChange() {
    // this.title = this.$route.meta.title;
  }

}

Vue.component("cmToolbar", ToolbarComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/toolbar/toolbar.ts